<template>
<div>
    <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <span class="headline">確認事項</span>
            </v-card-title>
            <v-container>
                <v-card-text style="text-align:center;font-size:15px;">
                    <div>カラー配置図（測定点入）を依頼する際は、下記の項目に注意お願い致します。</div>
                    <div><span style="color:red;">※</span>不備がありキャンセルされた場合も依頼回数に含まれ、</div>
                    <div>3回目以降（STOPチェック時は除く）の依頼は受付できません。</div>

                    <br><br>
                    <!-- <v-container>
                        地盤調査報告書がアップロードされていないと、配置図（測定点入）を作成することができません
                    </v-container> -->
                    <div style="text-align:left;color:blue;">
                        1）測定点位置図の方位または調査位置が、配置図と異なっている場合 <br>
                        2）設備シートにて地盤未調査となっている場合 <br>
                        3）地盤調査結果または現況図データがBOSSにアップロードされていない場合 <br>
                        4）地盤の測定点位置図を配置図の敷地寸法が異なる場合 <br>
                    </div>

                </v-card-text>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="success" @click="confirmJibanPlan()">保存</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {

        }
    },

    methods: {
        toggleDialogConfirmationItems(val){
            this.$emit('toggleDialogConfirmationItems', val)
        },

        confirmJibanPlan(){
            this.$emit('confirmJibanPlan', true)
            this.toggleDialogConfirmationItems(false)
        }
    }


}
</script>

<style>

</style>